export default __webpack_public_path__ + "static/media/developed-by.f6540a36.svg";